import en from './en.json';

export const translations = { en };
